export * from "./info";
export * from "./service-matrix";
export * from "./filter-icon";
export * from "./export-icon";
export * from "./info-icon-stroke";
export * from "./menu-icon";
export * from "./close-icon";
export * from "./check-icon";
export * from "./plus-icon";


import { InfoIcon } from "./info";
import { ServiceMatrixIcon } from "./service-matrix";
import { FilterIcon } from "./filter-icon";
import { ExportIcon } from "./export-icon";
import { InfoIconStroke } from "./info-icon-stroke";
import { MenuIcon } from "./menu-icon";
import { CloseIcon } from "./close-icon";
import { CheckIcon } from "./check-icon";
import { PlusIcon } from "./plus-icon";




export const MacdIcons = [
  InfoIcon,
  ServiceMatrixIcon,
  FilterIcon,
  MenuIcon,
  CloseIcon,
  ExportIcon,
  InfoIconStroke,
  CheckIcon,
  PlusIcon,
];
